var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopyButton(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 22.652,
    viewBox: "0 0 19.5 22.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_74_1",
    "data-name": "Component 74 \\u2013 1",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3162",
    "data-name": "Group 3162",
    transform: "translate(0 -0.848)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3161",
    "data-name": "Group 3161"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3160",
    "data-name": "Group 3160"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1556",
    "data-name": "Rectangle 1556",
    transform: "translate(3 4)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 19,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 18,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1662",
    "data-name": "Path 1662",
    d: "M13.652,0h1.091a1.725,1.725,0,0,1,1.843,1.576V16.548a1.725,1.725,0,0,1-1.843,1.576H1.843A1.725,1.725,0,0,1,0,16.548V14.906",
    transform: "translate(16.586 18.972) rotate(180)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("line", {
    id: "Line_557",
    "data-name": "Line 557",
    x2: 6.45,
    transform: "translate(5.989 8.754)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_558",
    "data-name": "Line 558",
    x2: 9.214,
    transform: "translate(5.989 11.518)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_559",
    "data-name": "Line 559",
    x2: 9.214,
    transform: "translate(5.989 14.282)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_560",
    "data-name": "Line 560",
    x2: 9.214,
    transform: "translate(5.989 17.047)",
    fill: "none",
    stroke: "#2c728a",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyButton);
export default __webpack_public_path__ + "static/media/copy-button.835191601f4ecaa0d70b952a74ef406f.svg";
export { ForwardRef as ReactComponent };